package com.eladfinish.bible.contest.screens.names.data

import kotlinx.serialization.Serializable

sealed class NamesLink {
    abstract val start: Int
    abstract val end: Int
}

data class LinkInfo(
    val url: String,
    override val start: Int,
    override val end: Int,
) : NamesLink()

@Serializable
data class InternalNameLink(
    val gender: Gender,
    val letter: Char,
    val name: String,
    override val start: Int,
    override val end: Int,
) : NamesLink()
